import * as React from 'react'
// import styled from '../../../../theme/styled'
import classNames from 'classnames'
import styled from '../../../../theme/styled'

export type FieldConfig = {
  title: string
}

const ErrorMsg = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.error};
  padding-bottom: 1em;
`

const UnitInput = props => {
  const { input, meta, title, unit, className, ...rest } = props
  return (
    <div>
      <label
        htmlFor={input.name}
        className={classNames({ 'read-only-value': rest.disabled })}
      >
        {title}
        <input
          className={classNames(className, {
            error: meta.touched && meta.error
          })}
          {...input}
          {...rest}
        />
      </label>
      {meta.touched && meta.error && <ErrorMsg>{meta.error}</ErrorMsg>}
    </div>
  )
}
export default UnitInput



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/Inputs/TextInput.tsx